<template>
  <div class="relative">
    <vs-input
      type="text"
      ref="autocompleteInput"
      label="Address 1"
      v-model="search"
      class="w-full mt-4 relative"
      @input="onInput"
      @focus="onFocus"
    />
    <div v-if="predictions.length" class="autocomplete-suggestions">
      <div
        v-for="prediction in predictions"
        :key="prediction.place_id"
        @click="selectPlace(prediction)"
        class="suggestion-item"
      >
        {{ prediction.description }}
      </div>
    </div>
  </div>
</template>

  <script>
export default {
  data() {
    return {
      predictions: [],
      autocompleteService: null,
      placesService: null,
      search: "",
    };
  },
  mounted() {
    if (!window.google || !window.google.maps) {
      console.error("Google Maps JavaScript API not loaded.");
      return;
    }

    this.autocompleteService = new google.maps.places.AutocompleteService();
    this.placesService = new google.maps.places.PlacesService(
      document.createElement("div")
    );
  },
  methods: {
    onInput(event) {
      const query = event;

      if (!query) {
        this.predictions = [];
        return;
      }

      this.autocompleteService.getPlacePredictions(
        {
          input: query,
          componentRestrictions: { country: "us" },
        },
        (predictions, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            this.predictions = predictions;
          } else {
            console.error("Error fetching place predictions:", status);
            this.predictions = [];
          }
        }
      );
    },
    onFocus() {
      this.onInput({ target: { value: this.$refs.autocompleteInput.value } });
    },
    selectPlace(prediction) {
      this.placesService.getDetails(
        { placeId: prediction.place_id },
        (place, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            this.search = place.formatted_address;

            this.$emit("place-selected", place);
          } else {
            console.error("Error fetching place details:", status);
          }
        }
      );

      this.predictions = [];
      this.$refs.autocompleteInput.value = prediction.description;
    },
  },
};
</script>

  <style scoped>
.autocomplete-suggestions {
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  top: 65px;
  width: 100%;
  background: white;
  z-index: 1000;
  z-index: 99;
  -webkit-box-shadow: 0px 5px 34px -14px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 5px 34px -14px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 5px 34px -14px rgba(0, 0, 0, 0.75);
}
.suggestion-item {
  padding: 8px;
  cursor: pointer;
}
.suggestion-item:hover {
  background: #f0f0f0;
}
</style>
